//This should match the app features in the SubscriptionPlan - used for feature checks
export const AppFeature = Object.freeze({
    AI_SEARCH_ASSISTANT: "AI_SEARCH_ASSISTANT",
    NOTICE_AI_CHAT: "NOTICE_AI_CHAT",
    SOURCE_HILMA: "SOURCE_HILMA",
    SOURCE_SMALLSCALE_FI: "SOURCE_SMALLSCALE_FI",
    SOURCE_TED: "SOURCE_TED",
    SOURCE_E_AVROP_SE: "SOURCE_E_AVROP_SE",
    SOURCE_KOMMERS_ANNONS_SE: "SOURCE_KOMMERS_ANNONS_SE",
    SOURCE_MERCELL_SE: "SOURCE_MERCELL_SE",
    SOURCE_CLIRA_SE: "SOURCE_CLIRA_SE",
    SOURCE_TENDSIGN_SE: "SOURCE_TENDSIGN_SE",
    SOURCE_DOFFIN_NO: "SOURCE_DOFFIN_NO",
    ADVANCED_SEARCH: "ADVANCED_SEARCH",
    DECISIONS: "DECISIONS",
    DECISIONS_AI_CHAT: "DECISIONS_AI_CHAT",
    EYE_AI_CHAT: "EYE_AI_CHAT",
    // Analytics hub + market overview, buyer analysis, competitor analysis (no AI narrative) - Pro+.
    MARKET_ANALYTICS: "MARKET_ANALYTICS",
    PIPELINE_BOARD: "PIPELINE_BOARD",
    EXCEL_EXPORT: "EXCEL_EXPORT",
    CRM_INTEGRATION: "CRM_INTEGRATION",
    COMPANY_IDENTITY: "COMPANY_IDENTITY",
    GOD_MODE_DECISION_ANALYSIS: "GOD_MODE_DECISION_ANALYSIS",
    GOD_MODE_NOTICE_COMPARATIVE_ANALYSIS: "GOD_MODE_NOTICE_COMPARATIVE_ANALYSIS",
    GOD_MODE_BUYER_PROFILE: "GOD_MODE_BUYER_PROFILE",
    GOD_MODE_PROCUREMENT_TIMELINE: "GOD_MODE_PROCUREMENT_TIMELINE",
    GOD_MODE_COMPARISON_CHART_ANALYZER: "GOD_MODE_COMPARISON_CHART_ANALYZER",
    // Silma Autopilot - DAILY_BRIEF / BID_LEDGER are unseeded (tendera.bid admins + org overrides only) for now;
    // the weekly digest reuses the pricing-sheet MARKET_DATA_NEWSLETTER entitlement.
    DAILY_BRIEF: "DAILY_BRIEF",
    BID_LEDGER: "BID_LEDGER",
    // "Tarjoa vai ei": the deterministic bid / no-bid sheet on a notice - Intelligence+ (tendera.bid staff always).
    BID_DECISION: "BID_DECISION",
    // Notice reports from question templates: Pro+ builds them from the Tendera catalog, Intelligence+ adds its own
    // questions; the PDF download is Intelligence+ as on the pricing sheet.
    NOTICE_PRESET_QUESTIONS: "NOTICE_PRESET_QUESTIONS",
    NOTICE_CUSTOM_QUESTIONS: "NOTICE_CUSTOM_QUESTIONS",
    AI_SUMMARY_PDF_REPORT: "AI_SUMMARY_PDF_REPORT",
    MARKET_DATA_NEWSLETTER: "MARKET_DATA_NEWSLETTER",
});
